import React, { useState, useEffect, useRef, useCallback } from "react";
import { ScreenSizeContext } from "./ScreenSizeContext";
import { EmailTemplateContext } from "./EmailTemplateContext";
import { SelectedElementContex } from "./SelectedElement";
import { HtmlCodeExtractedContext } from "./HtmlCodeExtracted";
import { TextEditorContext } from "./TextEditorContext";
import { TableRowColumnIndexContex } from "./TableRowColumnIndexContex";
import { DatabaseDropdownContext } from "./DatabaseDropdownContext";
import { ActiveEditorContext } from "./ActiveEditorContext";
import { useUndoRedo } from "../hooks/useUndoRedo";
import { GetHtmlCodeContext } from "./GetHtmlCodeContex";

export default function ScreenSizeProvider({ children }) {
  const [screenSize, setScreenSize] = useState("desktop");
  const [dragElementLayout, setDragElementLayout] = useState();
  const [editDiv, setEditDiv] = useState(true);
  const [indexRow, setIndexRow] = useState(null);
  const [indexColumn, setIndexColumn] = useState(null);

  const [attachments, setAttachments] = useState([]);
  const [sendToCcBccSubject, setSendToCcBccSubject] = useState({
    fromName:"EduSkills Foundation",
    fromEmail:"noreply@eduskillsfoundation.org",
    sendTo: "",
    sendToCc: "",
    sendToBcc: "",
    subjectFor: "",
  });

  const [selectedElement, setSelectedElement] = useState(null);
  const [htmlCode, setHtmlCode] = useState();
  const [saveEmailTemplate, setSaveEmailTemplate] = useState();

  const [isTextSelected, setIsTextSelected] = useState(false);

  const [applyStyleFn, setApplyStyleFn] = useState(() => () => {});
  const [saveFn, setSaveFn] = useState(() => () => {});
  const [textImgFn, setTextImgFn] = useState(() => () => {});
  const [getHtmlCodeFn, setGetHtmlCodeFn] = useState(() => null);
  const [isDragging, setIsDragging] = useState(false);
  const [showCursor, setShowCursor] = useState(false);
  const savedRangeRef = useRef(null);

  const [activeEditor, setActiveEditor] = useState(null);

  const [getStylesFn, setGetStylesFn] = useState(() => () => {});

  // Track if we should push to history
  const shouldTrackRef = useRef(true);

  const {
    state: emailTemplate,
    pushState: pushEmailTemplate,
    undo,
    redo,
    canUndo,
    canRedo,
    clearHistory,
  } = useUndoRedo([]);

  // useEffect(() => {
  //   if (typeof window !== undefined) {
  //     const storage = localStorage.getItem("accessToken");
  //     const emailTemplateStorage = JSON.parse(
  //       localStorage.getItem("emailTemplate")
  //     );
  //     const attachmentStorage = JSON.parse(
  //       localStorage.getItem("attachments")
  //     );
  //     setEmailTemplate(emailTemplateStorage ?? []);
  //     setAttachments(attachmentStorage ?? []);

  //     if (!storage) {
  //       // Redirect Home screen
  //       console.log("----------->byyyyy");
  //     } else {
  //       // console.log("----------->hiiii");
  //     }
  //   }
  // }, []);

  // ✅ Wrap setter to handle function storage properly
  const registerGetHtmlCodeFn = useCallback((fn) => {
    setGetHtmlCodeFn(() => fn);
  }, []);

  // Custom setEmailTemplate that tracks history
  const setEmailTemplate = (newStateOrUpdater) => {
    if (!shouldTrackRef.current) {
      shouldTrackRef.current = true;
      return;
    }

    const newState =
      typeof newStateOrUpdater === "function"
        ? newStateOrUpdater(emailTemplate)
        : newStateOrUpdater;

    pushEmailTemplate(newState);
  };

  // Undo handler
  const handleUndo = () => {
    if (canUndo) {
      shouldTrackRef.current = false;
      const prevState = undo();
      // prevState is already set by the hook
    }
  };

  // Redo handler
  const handleRedo = () => {
    if (canRedo) {
      shouldTrackRef.current = false;
      const nextState = redo();
      // nextState is already set by the hook
    }
  };

  // 🔧 FIXED: Safe JSON parsing with error handling
  useEffect(() => {
    if (typeof window !== "undefined") {
      const storage = localStorage.getItem("accessToken");

      // Safe parsing for emailTemplate
      let emailTemplateStorage = [];
      try {
        const emailTemplateData = localStorage.getItem("emailTemplate");
        if (
          emailTemplateData &&
          emailTemplateData !== "undefined" &&
          emailTemplateData !== "null"
        ) {
          emailTemplateStorage = JSON.parse(emailTemplateData);
        }
      } catch (error) {
        console.error("Error parsing emailTemplate from localStorage:", error);
        emailTemplateStorage = [];
      }

      // Safe parsing for attachments
      let attachmentStorage = [];
      try {
        const attachmentData = localStorage.getItem("attachments");
        if (
          attachmentData &&
          attachmentData !== "undefined" &&
          attachmentData !== "null"
        ) {
          attachmentStorage = JSON.parse(attachmentData);
        }
      } catch (error) {
        console.error("Error parsing attachments from localStorage:", error);
        attachmentStorage = [];
      }

      // Safe parsing for attachments
      let sendToCcBccStorage = [];
      try {
        const sendToCcBccSubjectData =
          localStorage.getItem("sendToCcBccSubject");
        if (
          sendToCcBccSubjectData &&
          sendToCcBccSubjectData !== "undefined" &&
          sendToCcBccSubjectData !== "null"
        ) {
          sendToCcBccStorage = JSON.parse(sendToCcBccSubjectData);
        }
      } catch (error) {
        console.error(
          "Error parsing sendToCcBccSubject from localStorage:",
          error
        );
        sendToCcBccStorage = {
          fromName:"EduSkills Foundation",
          fromEmail:"noreply@eduskillsfoundation.org",
          sendTo: "",
          sendToCc: "",
          sendToBcc: "",
          subjectFor: "",
        };
      }

      setEmailTemplate(emailTemplateStorage ?? []);
      setAttachments(attachmentStorage ?? []);
      setSendToCcBccSubject(
        sendToCcBccStorage ?? {
          fromName:"EduSkills Foundation",
          fromEmail:"noreply@eduskillsfoundation.org",
          sendTo: "",
          sendToCc: "",
          sendToBcc: "",
          subjectFor: "",
        }
      );

      // if (!storage) {
      //   // Redirect Home screen
      // } else {
      //   // console.log("----------->hiiii");
      // }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== undefined) {
      // console.log("emailTemplate : --"+JSON.stringify(emailTemplate))
      localStorage.setItem("emailTemplate", JSON.stringify(emailTemplate));
    }
  }, [emailTemplate]);
  useEffect(() => {
    if (typeof window !== undefined) {
      // console.log("emailTemplate : --"+JSON.stringify(emailTemplate))
      localStorage.setItem("attachments", JSON.stringify(attachments));
    }
  }, [attachments]);
  useEffect(() => {
    if (typeof window !== undefined) {
      // console.log("emailTemplate : --"+JSON.stringify(emailTemplate))
      localStorage.setItem(
        "sendToCcBccSubject",
        JSON.stringify(sendToCcBccSubject)
      );
    }
  }, [sendToCcBccSubject]);

  useEffect(() => {
    if (selectedElement) {
      let updatedEmailtemplate = [];
      emailTemplate.forEach((item, index) => {
        if (item.id === selectedElement?.layout?.id) {
          updatedEmailtemplate?.push(selectedElement?.layout);
        } else {
          updatedEmailtemplate?.push(item);
        }
      });
      setEmailTemplate(updatedEmailtemplate);
    }
  }, [selectedElement]);

  return (
    <ScreenSizeContext.Provider
      value={{
        screenSize,
        setScreenSize,
        dragElementLayout,
        setDragElementLayout,
      }}
    >
      <GetHtmlCodeContext.Provider value={{
          getHtmlCode: getHtmlCodeFn, 
          registerGetHtmlCode: registerGetHtmlCodeFn
        }}>
      <EmailTemplateContext.Provider
        value={{
          emailTemplate,
          setEmailTemplate,
          attachments,
          setAttachments,
          // ✅ Expose undo/redo functions
          undo: handleUndo,
          redo: handleRedo,
          canUndo,
          canRedo,
          clearHistory,
          sendToCcBccSubject,
          setSendToCcBccSubject,
        }}
      >
        <SelectedElementContex.Provider
          value={{ selectedElement, setSelectedElement, editDiv, setEditDiv }}
        >
          <HtmlCodeExtractedContext.Provider value={{ htmlCode, setHtmlCode, saveEmailTemplate, setSaveEmailTemplate }}>
            <TextEditorContext.Provider
              value={{
                isTextSelected,
                setIsTextSelected,
                registerApplyStyle: setApplyStyleFn,
                registerSaveHandler: setSaveFn,
                applyStyleToSelection: applyStyleFn,
                saveTextareaChanges: saveFn,
                registerInsertImage: setTextImgFn,
                insertImageAtCursor: textImgFn,
                registerGetStyles: setGetStylesFn,
                getAppliedStyles: getStylesFn,
              }}
            >
              <TableRowColumnIndexContex.Provider
                value={{
                  indexRow,
                  setIndexRow,
                  indexColumn,
                  setIndexColumn,
                  savedRangeRef,
                }}
              >
                <DatabaseDropdownContext.Provider
                  value={{
                    isDragging,
                    setIsDragging,
                    showCursor,
                    setShowCursor,
                  }}
                >
                  <ActiveEditorContext.Provider
                    value={{ activeEditor, setActiveEditor }}
                  >
                    
                    {children}
                  </ActiveEditorContext.Provider>
                </DatabaseDropdownContext.Provider>
              </TableRowColumnIndexContex.Provider>
            </TextEditorContext.Provider>
          </HtmlCodeExtractedContext.Provider>
        </SelectedElementContex.Provider>
      </EmailTemplateContext.Provider>
      </GetHtmlCodeContext.Provider>
    </ScreenSizeContext.Provider>
  );
}
